import { Box, Card, CardMedia, InputLabel, Skeleton } from '@mui/material';
import { useRef } from 'react';
import FileUpload from 'components/common/FileUpload';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import defaultImage from 'components/VideoCard/defaultImage.svg';

export const ImageUploadButton = ({
  value,
  image,
  register,
  onChange,
  disabled,
  loading,
  variant = 'SQUARE',
}) => {
  const fileInputRef = useRef();

  const styleByVariant = {
    SQUARE: {
      width: 300,
      height: 300,
      title: 'Thumbnail quadrado',
      name: 'video_thumbnail-square',
      id: 'video-thumb-square',
    },
    VERTICAL: {
      width: 300 * 0.698182, // 0.698182 image size ratio
      height: 300,
      title: 'Thumbnail vertical',
      name: 'video_thumbnail-vertical',
      id: 'video-thumb-vertical',
    },
  };

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: styleByVariant[variant].width,
          }}>
          <InputLabel
            sx={{
              alignSelf: 'start',
            }}
            className="select-label"
            id="video-square-thumb">
            {styleByVariant[variant].title}
          </InputLabel>
          {!loading && (
            <Card
              variant="outlined"
              sx={{
                padding: 1,
                width: styleByVariant[variant].width,
                height: styleByVariant[variant].height,
                display: 'flex',
                justifyContent: 'center',
                marginBottom: 2,
              }}>
              <CardMedia
                className="SQUARE"
                component="img"
                image={image || defaultImage}
                alt=""
              />
            </Card>
          )}
          {loading && (
            <Skeleton
              sx={{
                marginBottom: 2,
              }}
              variant="rectangular"
              width={styleByVariant[variant].width}
              height={styleByVariant[variant].height}
            />
          )}
          <FileUpload
            register={register}
            name={styleByVariant[variant].name}
            icon={<FileUploadOutlinedIcon />}
            style={{
              width: '300px',
            }}
            accept={'image/*'}
            idioma={value}
            fileInputRef={fileInputRef}
            file={value}
            title="Selecionar imagem"
            onChange={onChange}
            isDisabled={disabled}
            id={styleByVariant[variant].id}
          />
        </Box>
      </Box>
    </div>
  );
};
